import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { curationMenu, portfolioMenu } from "../data/Menu";
import HeaderMobileNav from "./HeaderMobileNav";
import HeaderDesktopNav from "./HeaderDesktopNav";
import HeaderControls from "./HeaderControls";

const portfolioSubmenu = portfolioMenu
  .filter((item) => item.link)
  .map((item) => ({
    label: item.label,
    link: item.link,
  }));

const curationSubmenu = curationMenu
  .filter((item) => item.submenu?.length)
  .flatMap((item) =>
    item.submenu
      .filter((submenu) => submenu.link)
      .map((submenu) => ({
        label: `${item.label} · ${submenu.label}`,
        link: submenu.link,
      }))
  );

const newsSubmenu = curationMenu
  .filter((item) => !item.submenu?.length && item.link)
  .map((item) => ({
    label: item.label,
    link: item.link,
  }));

const HEADER_PRIMARY_MENU = [
  { key: "portfolio", label: "포트폴리오", link: "/guru", submenu: portfolioSubmenu },
  { key: "curation", label: "큐레이션", link: "/curation/guruSale", submenu: curationSubmenu },
  { key: "news", label: "뉴스", link: "/news", submenu: newsSubmenu },
  { key: "about_us", label: "소개", link: "/intro/aboutus" }
];

export default function Header({ onSkin = () => { } }) {
  const location = useLocation();
  const activePath = location.pathname;

  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const [desktopMenuOpenKey, setDesktopMenuOpenKey] = useState("");
  const [mobileMenuOpenKey, setMobileMenuOpenKey] = useState("");

  const [skinModeState, setSkinModeState] = useState(
    localStorage.getItem("skin-mode") === "light" ? "light" : "dark"
  );

  const isRouteActive = (link) => {
    return activePath === link || activePath.startsWith(`${link}/`);
  };

  const isPrimaryMenuActive = (menu) => {
    if (menu.key === "curation") {
      return activePath.startsWith("/curation");
    }
    if (menu.link && isRouteActive(menu.link)) return true;
    return menu.submenu?.some((submenu) => isRouteActive(submenu.link)) || false;
  };

  const toggleSkinMode = () => {
    const nextSkin = skinModeState === "dark" ? "light" : "dark";
    let HTMLTag = document.querySelector("html");

    if (nextSkin === "dark") {
      HTMLTag.setAttribute("data-skin", "dark");
      localStorage.setItem("skin-mode", "dark");
      setSkinModeState("dark");
      onSkin("dark");
    } else {
      HTMLTag.removeAttribute("data-skin");
      localStorage.setItem("skin-mode", "light");
      setSkinModeState("light");
      onSkin("");
    }
  };

  return (
    <div className={`header-main d-flex align-items-center justify-content-between px-3 px-lg-4 gap-2 ${isMobileSearchOpen ? "mobile-search-open" : ""}`}>
      {/* Left */}
      <div className="header-main-left d-flex align-items-center flex-shrink-0 gap-2">
        <HeaderMobileNav
          menus={HEADER_PRIMARY_MENU}
          mobileMenuOpenKey={mobileMenuOpenKey}
          setMobileMenuOpenKey={setMobileMenuOpenKey}
          isPrimaryMenuActive={isPrimaryMenuActive}
          isRouteActive={isRouteActive}
        />
        <Link to="/" className="header-brand d-inline-flex align-items-center gap-2 text-decoration-none flex-shrink-0" aria-label="Whisper 홈">
          <span className="header-brand-text">WHISPER</span>
        </Link>
      </div>

      {/* Center */}
      <HeaderDesktopNav
        menus={HEADER_PRIMARY_MENU}
        desktopMenuOpenKey={desktopMenuOpenKey}
        setDesktopMenuOpenKey={setDesktopMenuOpenKey}
        isPrimaryMenuActive={isPrimaryMenuActive}
        isRouteActive={isRouteActive}
      />

      {/* Right */}
      <HeaderControls
        isMobileSearchOpen={isMobileSearchOpen}
        setIsMobileSearchOpen={setIsMobileSearchOpen}
        skinModeState={skinModeState}
        toggleSkinMode={toggleSkinMode}
      />
    </div>
  );
}
